'use strict';

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: '',
    account: '',
    profile: '',
  },
  mutations: {
    updateAccount(state, account) {
      state.account = account;
    },
    updateProfile(state, profile) {
      state.profile = profile;
    },
    updateAccessToken(state, token) {
      state.accessToken = token;
    },
    clearState(state) {
      state.accessToken = {};
      state.account = {};
      state.profile = {};
    },
  },
  getters: {
    returnAccount: (state) => {
      if (state.account) {
        console.log(state.account);
        return state.account;
      } else {
        return null;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js